export const isStringEmptyOrWhiteSpace = (str: string | null | undefined) =>
  str === null || str === undefined || /^ *$/.exec(str) !== null;
